import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core';

import API from 'api/api';
import { ROUTES, ERROR_UPLOAD, FINANCIAL_STREAM_VOUCHER } from 'constants/constants';
import { useSentryUtils } from 'common-components/SentryUtils/SentryUtilsProvider';
import { getFinancialSourceRequestBody } from 'utils/misc';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import withTransactionPath from 'utils/withTransactionPath';

import Page from 'common-components/Page/Page';
import AddFinancialSourceForm from 'pages/Banking/components/AddFinancialSourceForm';
import BankingContext from 'pages/Banking/BankingContext';
import voucherSVG from 'assets/new-icons/voucher.svg';
import { withRouter } from 'react-router';

import { blackLinkRoot, arrowIcon } from 'assets/styles';

const useStyles = makeStyles(() => ({
    pageImage: {
        width: 100,
        height: 100,
    },
}));

// TODO: refactor component usable for both income, assets and vouchers? created by: @JimVercoelen | Ticket: NESTIO-19929
const AddVoucherSourcePage = (props) => {
    const context = useContext(BankingContext);
    const { logToSentry } = useSentryUtils();
    const [errors, setErrors] = useState([]);
    const classes = useStyles();
    const nextOrBackUrl = props.getTransactionPath(ROUTES.PROFILE_OPTIONS);

    const onSubmit = async (values, { setSubmitting }) => {
        context.toggleLoader(true);
        setSubmitting(true);
        setErrors([]);
        try {
            await API.submitFinancialSource(
                props.leaseTransaction.id,
                getFinancialSourceRequestBody(values, FINANCIAL_STREAM_VOUCHER)
            );
            await context.refreshFinancialSources();
            await context.fetchTransaction();
            props.history.push(props.getTransactionPath(`${ROUTES.INCOME_VERIFICATION_SUMMARY}#assets`), null);
        } catch (e) {
            logToSentry(e);
            setErrors([ERROR_UPLOAD]);
        } finally {
            context.toggleLoader(false);
            setSubmitting(false);
        }
    };

    const notifications = [];
    if (errors) {
        notifications.push({
            type: 'error',
            notifications: errors,
        });
    }

    return (
        <Page
            title="Housing Voucher"
            notifications={notifications}
            image={{
                src: voucherSVG,
                className: classes.pageImage,
            }}
        >
            <AddFinancialSourceForm
                initialValues={props.initialValues}
                financialType={FINANCIAL_STREAM_VOUCHER}
                onSubmit={onSubmit}
                setError={(err) => setErrors(err)}
            />
            <a
                href={nextOrBackUrl}
                className={blackLinkRoot}
                onClick={(e) => {
                    e.preventDefault();
                    props.setVoucher(false);
                    props.history.push(nextOrBackUrl, null);
                }}
            >
                <ArrowBackIos classes={{ root: arrowIcon }} />
                Go Back
            </a>
        </Page>
    );
};

AddVoucherSourcePage.propTypes = {
    history: PropTypes.object,
    initialValues: PropTypes.object,
    vgsEnabled: PropTypes.bool,
    leaseTransaction: PropTypes.object.isRequired,
    getTransactionPath: PropTypes.func.isRequired,
    setVoucher: PropTypes.func,
};

const mapStateToProps = (state) => ({
    vgsEnabled: state.configuration.enable_encryption,
    leaseTransaction: state.transaction,
});

const mapActionsToProps = null;

export default connect(mapStateToProps, mapActionsToProps)(withRouter(withTransactionPath(AddVoucherSourcePage)));
